export const ServicesAll = [
  {
    mainHeader: 'Corporate Security',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Our adaptive and future focused approach makes us the optimal choice of our clients in security. Our focus is not only on understanding our client’s needs and expectations but also their satisfaction.</span><br/><br/>As an owner-manager company, we are proud of the quality performance of our team and the repeat business we continue to earn. We will always provide our high-grade clients with a prudent, professional and specially designed security service that consistently meets and exceeds their expectations.<br/><br/>Our security services provide high standards of integrity and excellence on provision of all the services. The reason behind us being one of the leading security companies in London, United Kingdom is the quality assurance of our services, professionalism and expertise. We have integrated these in our organization by making it our core mission, vision and value statement.',

    subservices: [
      {
        icon: '/corporate-security.jpg',
        title: 'Corporate Security',
        desc: 'Professional guards for your office premises and business centers, ensuring safety and peace of mind.',
      },
      {
        icon: '/corporate-guarding.jpg',
        title: 'Corporate Guarding',
        desc: 'Professional guards for your office premises and business centers.',
      },
      {
        icon: '/corporate-surveillance.jpg',
        title: 'Surveillance & Monitoring',
        desc: 'Real-time monitoring and surveillance of your corporate facilities.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🛡️',
        title: 'Reliable Protection',
        desc: 'We ensure your corporate premises are secure 24/7.',
      },
      {
        icon: '👔',
        title: 'Professional Staff',
        desc: 'Trained and vetted security personnel at your service.',
      },
      {
        icon: '📋',
        title: 'Tailored Plans',
        desc: 'Security solutions customized for your organization.',
      },
    ],
    downHeader: 'Why Choose Next-G Services for Corporate Security',
    downSubHeader:
      'Next-G Services delivers top-tier corporate security solutions for your business, events, and assets.',
    link: '/corporate-security',
  },
  {
    mainHeader: 'Concierge Services',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Next-G Service believes that a friendly and warm- hearted reception assistance leaves a good mark on visitors and makes them feel comfortable.</span><br/><br/>Our attended team includes highly devoted individuals who provide extraordinary customer care. They are SIA licensed and DBS checked. The particular of our service is displayed through our guard’s customer service skill. All the short term and long term security requirements are dealt with the same professionalism. The guards represent the company with apt knowledge of their past, your company and morals. They dress smartly every day and display their work in a nice and polite way, and communicate with staff, customers, employees and colleagues.<br/><br/>Different industries use concierge security like apartments, golf clubs, hospitals, hotels, etc. The main purpose of guards is to secure premises, inspect buildings, permit equipment to authorized personnel only by using written logs, ensure positive customer care, and lock premises at a specific time. The guards will always work in teams, confidently report irregularities, maintain the safety of visitors, and act as first aiders, fire marshals, and traffic marshals in emergency situations. The control room provides 24-hour service to offer advice to guards. Night visits ensure our high standard is maintained. An account manager will be appointed for your site to collect your feedback and resolve any issues.',

    subservices: [
      {
        icon: '/concierge.png',
        title: 'Concierge Desk',
        desc: 'Front desk support and visitor management.',
      },
      {
        icon: '/lobby-management.jpg',
        title: 'Lobby Management',
        desc: 'Organizing and monitoring building entrances.',
      },
      {
        icon: '/guest-assistance.jpg',
        title: 'Guest Assistance',
        desc: 'Assisting VIPs, clients, and staff efficiently.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🤝',
        title: 'Friendly Staff',
        desc: 'Our concierge team welcomes and assists visitors professionally.',
      },
      {
        icon: '🕒',
        title: '24/7 Service',
        desc: 'Reliable concierge coverage whenever you need it.',
      },
      {
        icon: '🔐',
        title: 'Secure Assistance',
        desc: 'Combines hospitality with security protocols.',
      },
    ],
    downHeader: 'Why Choose Next-G Services for Concierge Services',
    downSubHeader:
      'Next-G Services offers concierge staff trained in security, hospitality, and professional assistance.',
    link: '/concierge-services',
  },
  {
    mainHeader: 'Construction Security & Services',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Along with vacant houses, Construction sites are the most looted and vandalized sites in the country according to National Insurance Crime Bureau. Keeping in view such statistics, a competent and effective security strategy is obligatory.</span><br/><br/>The main concern of a construction site security is access, particularly when the crew is not on site. Our guards keep a record of crew and visitors signing in and out of the building<br/><br/>Construction sites have expensive machinery and material stored, which can be really tempting for criminals. Our guards will not release any equipment without written consent from an authorized person.Our guards are SIA licensed and performed security tasks with full devotion. Our security officers have expertise in analyzing a site upon arrival. They identify any security issues that should be addressed. We’re glad to offer up to 24-hour security seven days per week. Our guards help you regularly monitor the security requirements of your site. They make sure that minor problems are fixed in a timely manner.',
    subservices: [
      {
        icon: '/constructionsecurity.webp',
        title: 'Site Guarding',
        desc: 'Professional guards for construction sites.',
      },
      {
        icon: '/equipment-monitoring.jpg',
        title: 'Equipment Monitoring',
        desc: 'Prevent theft or misuse of machinery and tools.',
      },
      {
        icon: '/access-control.png',
        title: 'Access Control',
        desc: 'Control who enters and leaves your site safely.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏗️',
        title: 'Site Protection',
        desc: 'Prevent theft, vandalism, and unauthorized access on construction sites.',
      },
      {
        icon: '🚨',
        title: 'Emergency Response',
        desc: 'Rapid action in case of incidents or alarms.',
      },
      {
        icon: '🛠️',
        title: 'Custom Security',
        desc: 'Tailored plans for each construction project.',
      },
    ],
    downHeader: 'Why Choose Next-G Services for Construction Security',
    downSubHeader:
      'Next-G Services ensures all construction sites remain safe, compliant, and secure.',
    link: '/construction-security-services',
  },
  {
    mainHeader: 'Remote Monitoring',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Next-G provides an extensive range of devices like door locks, fire detector, cameras, lightning controls and garage door openers. These devices are connected to a security alarm to alert you when something goes wrong.</span><br/><br/>Next-G offers a variety of alarm and video surveillance systems which alert you by text, email or phone if any of the conditions fall outside the domain of preset parameters so you can counter the problem quickly. The alarm when activated, the monitoring system will contact the concerned person and also the emergency services if required.<br/><br/>Next-G helps you control access to and within your building. Next-G can can solve all your problems like video surveillance, keyless entry, badging system for offices or colleges etc. Just call us and we’ll figure out and install the right design as per your need.Next-G not only provides monitoring systems for houses but also for commercial purposes. We can install remote monitoring systems at your private or commercial property. CCTV feed can be connected to your smart phone or can be monitored by our surveillance station. With our high- quality video and smart network utilization techniques, your safety and security will be highly improved. Now you don’t have to worry while leaving your property, we’ll protect it for you.',

    subservices: [
      {
        icon: '/remotemonitoring.jpg',
        title: 'Video Surveillance',
        desc: 'Continuous live feed monitoring of your premises.',
      },
      {
        icon: '/alarm-monitoring.jpg',
        title: 'Alarm Monitoring',
        desc: 'Instant alerts for any triggered alarms or breaches.',
      },
      {
        icon: '/sensor-integration.jpg',
        title: 'Sensor Integration',
        desc: 'Integration with IoT and smart sensors for advanced monitoring.',
      },
    ],
    whyChooseUs: [
      {
        icon: '📹',
        title: '24/7 Monitoring',
        desc: 'Continuous surveillance from our control center.',
      },
      {
        icon: '⚡',
        title: 'Quick Alerts',
        desc: 'Instant notifications if any suspicious activity occurs.',
      },
      {
        icon: '🔍',
        title: 'Detailed Reports',
        desc: 'Regular updates on incidents and monitoring activities.',
      },
    ],
    downHeader: 'Why Choose Next-G Services for Remote Monitoring',
    downSubHeader:
      'Next-G Services provides professional remote monitoring to keep your assets safe at all times.',
    link: '/remote-monitoring',
  },
  {
    mainHeader: 'Industrial & Warehouse Security & Services',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Next-G has a team of highly skilled professional guards. Next-G offers exemplary exercise sessions to their guards and provide them with the modern technological gadgets for excellent onsite performance.</span><br/><br/>Our guards use radios, security cameras along with the latest gadgets to ensure the safety of the establishment. Next-G offers access control to allow only authorized people to enter the premises. The time of employees signing in and out of the building is also noted. The security guards keep a record of unauthorized entries and note down necessary details like names, addresses, date and time, number plates of vehicles and their purpose of visit. The guards are trained and have years of experience to handle emergency situations that may occur in your establishment.<br/><br/>Industrial warehouses are a fundamental part of the distribution chain and are mandatory to be protected by a security guard. Next-G can arrange the security coverage according to client’s demands, whether it is in the form of identity checks, premises checks, patrolling, activity logs, or employee escorts. Apart from protecting your employees and the property, Next-G also oversee the maintenance work needed to be done within the warehouse.',
    subservices: [
      {
        icon: '/industrialwarehouse.jpg',
        title: 'Facility Guarding',
        desc: 'Trained guards for warehouses and industrial sites.',
      },
      {
        icon: '/inventory-monitoring.webp',
        title: 'Inventory Monitoring',
        desc: 'Prevent losses and manage stock securely.',
      },
      {
        icon: '/patrol-services.webp',
        title: 'Patrol Services',
        desc: 'Scheduled and random patrols for full coverage.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏭',
        title: 'Facility Protection',
        desc: 'Ensure warehouses and industrial sites remain secure.',
      },
      {
        icon: '🚓',
        title: 'Patrols & Response',
        desc: 'Regular patrols and rapid incident response.',
      },
      { icon: '📦', title: 'Asset Safety', desc: 'Minimize risks to goods and equipment.' },
    ],
    downHeader: 'Why Choose Next-G Services for Industrial & Warehouse Security',
    downSubHeader:
      'Next-G Services ensures industrial and warehouse operations stay safe, compliant, and secure.',
    link: '/industrial-warehouse-security',
  },

  {
    mainHeader: 'Mobile Patrols',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Mobile patrolling is an efficient and cost effective alternative to employing a full time static site security guard. So, no matter the size of your business, Next-G Security has a solution that fits you and your requirements.</span><br/><br/>To understand the client’s requirement fully, an initial site survey will be carried out to establish what type of mobile service is required. Agreed Terms of Business will be established in the discussion with the client, including key factors, like frequency of patrol, duration of patrols, whether they are internal or external; or both. Patrols can be covert or overt and reported to you by email with photographs of any issues to be addressed.<br/><br/>Our services are also available on short notice and payable on a per visit basis. This means that budgeting for your security provision is made much simpler using this service.<br/><br/><div style="color:#828FA0;font-size:1.6rem;line-height:2rem;"><div style="display:flex;align-items:center;margin-bottom:0.5rem;"><svg style="width:1.6rem;height:1.6rem;margin-right:0.6rem;flex-shrink:0;" viewBox="0 0 16 16" fill="#FFFFFF"><path d="M6.173 14.727L.4 8.954l2.12-2.121 3.653 3.652L13.48 3.18l2.12 2.12-9.427 9.427z"/></svg>Patrols – mobile or on-foot subject to budget and requirements</div><div style="display:flex;align-items:center;margin-bottom:0.5rem;"><svg style="width:1.6rem;height:1.6rem;margin-right:0.6rem;flex-shrink:0;" viewBox="0 0 16 16" fill="#FFFFFF"><path d="M6.173 14.727L.4 8.954l2.12-2.121 3.653 3.652L13.48 3.18l2.12 2.12-9.427 9.427z"/></svg>Looking for break-in’s, fence or barrier collapse</div><div style="display:flex;align-items:center;margin-bottom:0.5rem;"><svg style="width:1.6rem;height:1.6rem;margin-right:0.6rem;flex-shrink:0;" viewBox="0 0 16 16" fill="#FFFFFF"><path d="M6.173 14.727L.4 8.954l2.12-2.121 3.653 3.652L13.48 3.18l2.12 2.12-9.427 9.427z"/></svg>Immediate response time – significantly quicker than police</div><div style="display:flex;align-items:center;margin-bottom:0.5rem;"><svg style="width:1.6rem;height:1.6rem;margin-right:0.6rem;flex-shrink:0;" viewBox="0 0 16 16" fill="#FFFFFF"><path d="M6.173 14.727L.4 8.954l2.12-2.121 3.653 3.652L13.48 3.18l2.12 2.12-9.427 9.427z"/></svg>Checking potential fire hazards</div><div style="display:flex;align-items:center;margin-bottom:0.5rem;"><svg style="width:1.6rem;height:1.6rem;margin-right:0.6rem;flex-shrink:0;" viewBox="0 0 16 16" fill="#FFFFFF"><path d="M6.173 14.727L.4 8.954l2.12-2.121 3.653 3.652L13.48 3.18l2.12 2.12-9.427 9.427z"/></svg>Guards prove to be a strong deterrent against crime and anti social activities</div><div style="display:flex;align-items:center;margin-bottom:0.5rem;"><svg style="width:1.6rem;height:1.6rem;margin-right:0.6rem;flex-shrink:0;" viewBox="0 0 16 16" fill="#FFFFFF"><path d="M6.173 14.727L.4 8.954l2.12-2.121 3.653 3.652L13.48 3.18l2.12 2.12-9.427 9.427z"/></svg>Random patrols to avoid detection by intruders</div><div style="display:flex;align-items:center;margin-bottom:0.5rem;"><svg style="width:1.6rem;height:1.6rem;margin-right:0.6rem;flex-shrink:0;" viewBox="0 0 16 16" fill="#FFFFFF"><path d="M6.173 14.727L.4 8.954l2.12-2.121 3.653 3.652L13.48 3.18l2.12 2.12-9.427 9.427z"/></svg>Reporting any potential security issues</div><div style="display:flex;align-items:center;margin-bottom:0.5rem;"><svg style="width:1.6rem;height:1.6rem;margin-right:0.6rem;flex-shrink:0;" viewBox="0 0 16 16" fill="#FFFFFF"><path d="M6.173 14.727L.4 8.954l2.12-2.121 3.653 3.652L13.48 3.18l2.12 2.12-9.427 9.427z"/></svg>Reporting any potential health and safety issues</div></div>',
    subservices: [
      {
        icon: '/mobilepatrols.jpg',
        title: 'Patrol Services',
        desc: 'Flexible patrolling for residential and commercial areas.',
      },
      {
        icon: '/rapid-response.jpg',
        title: 'Rapid Response',
        desc: 'Quick response to alarms and emergencies.',
      },
      {
        icon: '/incident-reporting.png',
        title: 'Incident Reporting',
        desc: 'Detailed reports on patrol findings and incidents.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🚓',
        title: 'Rapid Response',
        desc: 'Patrols ready to respond to incidents immediately.',
      },
      {
        icon: '🕒',
        title: 'Flexible Schedules',
        desc: 'Custom patrols to suit your security needs.',
      },
      { icon: '👮', title: 'Trained Officers', desc: 'Professional mobile patrol teams on duty.' },
    ],
    downHeader: 'Why Choose Next-G Services for Mobile Patrols',
    downSubHeader:
      'Next-G Services provides mobile patrols to keep your property safe and secure around the clock.',
    link: '/mobile-patrols',
  },
  {
    mainHeader: 'Cleaning Services',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Next-G provides supreme hotel security solutions for safety and services for the comfort of your customers. The hotel services offered by us are unmatchable. We put first the customer’s protection and comfort so that they feel secured and relaxed.</span><br/><br/>We ensure that the officers we send are responsible and committed. Officers are fully trained to deal with issues like theft in and around the hotel. We provide internal and external patrols, authorized room checks, access control and staff and customer harassment prevention. We will meet you at site for a complete survey regarding the services you require. Your account manager and our supervisor will visit the site on monthly basis to check if our guards are working to an optimum level. In addition to providing security our team is dedicated to provide great customer care. We are available for one-off, ad- hoc, event cover, temporary, short and long term cover during the day and night or when your staff/concierge cannot make their shift. We cover all the hotels nationwide and do not let our customers down.<br/><br/>Next-G Services also offers cleaning services to our customers. Your house, office, hotel room or apartment requires constant attention. Whether it be one time service, regular or a housekeeping job, Next-G Services will never disappoint you. Our cleaning services includes kitchens, floors, dusting, making bed, garage cleaning, car wash, vacuuming, bathrooms, windows, patios and linens. We also provide special cleaning services on client’s demand.',
    subservices: [
      {
        icon: '/cleaning-security.jpg',
        title: 'Office Cleaning',
        desc: 'Daily and periodic cleaning of office spaces.',
      },
      {
        icon: '/industrial-cleaning.webp',
        title: 'Industrial Cleaning',
        desc: 'Specialized cleaning for warehouses and factories.',
      },
      {
        icon: '/sanitization.jpg',
        title: 'Sanitization Services',
        desc: 'Disinfection and hygiene services for safety.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🧼',
        title: 'Thorough Cleaning',
        desc: 'Attention to hygiene and detail in all areas.',
      },
      { icon: '🛡️', title: 'Secure Staff', desc: 'Trained personnel who follow safety protocols.' },
      { icon: '⏱️', title: 'Flexible Schedule', desc: 'Cleaning services to fit your timetable.' },
    ],
    downHeader: 'Why Choose Next-G Services for Cleaning',
    downSubHeader:
      'Next-G Services ensures clean, secure, and safe environments for your business or property.',
    link: '/cleaning-services',
  },
  {
    mainHeader: 'Hotel Porter Services',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Next-G provides supreme hotel security solutions for safety and services for the comfort of your customers. The hotel services offered by us are unmatchable. We put first the customer’s protection and comfort so that they feel secured and relaxed.</span><br/><br/>We ensure that the officers we send are responsible and committed. Officers are fully trained to deal with issues like theft in and around the hotel. We provide internal and external patrols, authorized room checks, access control and staff and customer harassment prevention. We will meet you at site for a complete survey regarding the services you require. Your account manager and our supervisor will visit the site on monthly basis to check if our guards are working to an optimum level. In addition to providing security our team is dedicated to provide great customer care. We are available for one-off, ad- hoc, event cover, temporary, short and long term cover during the day and night or when your staff/concierge cannot make their shift. We cover all the hotels nationwide and do not let our customers down.<br/><br/>Next-G Services also offers cleaning services to our customers. Your house, office, hotel room or apartment requires constant attention. Whether it be one time service, regular or a housekeeping job, Next-G Services will never disappoint you. Our cleaning services includes kitchens, floors, dusting, making bed, garage cleaning, car wash, vacuuming, bathrooms, windows, patios and linens. We also provide special cleaning services on client’s demand.',
    subservices: [
      {
        icon: '/hotelporter.avif',
        title: 'Guest Assistance',
        desc: 'Help guests with luggage and guidance.',
      },
      {
        icon: '/hotel-security.webp',
        title: 'Property Monitoring',
        desc: 'Ensure hotel premises are safe and secure.',
      },
      {
        icon: '/logistics-management.webp',
        title: 'Logistics Support',
        desc: 'Assist hotel operations efficiently.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏨',
        title: 'Guest Assistance',
        desc: 'Professional and courteous staff for hotel guests.',
      },
      {
        icon: '🧳',
        title: 'Efficient Service',
        desc: 'Manage luggage, guidance, and hotel logistics smoothly.',
      },
      {
        icon: '🛡️',
        title: 'Security-Conscious',
        desc: 'Porters trained to monitor property and guests safely.',
      },
    ],
    downHeader: 'Why Choose Next-G Services for Hotel Porter Services',
    downSubHeader:
      'Next-G Services provides efficient and secure porter services to hotels and hospitality venues.',
    link: '/hotel-porter-services',
  },
  {
    mainHeader: 'Event Security',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">We offer the level of protection you need for an extensive range of situations, from security for individuals to security for a huge crowd.</span><br/><br/>By careful evaluation, we can decide how much security personnels you need and where. We will help you by highlighting the challenges you need to consider while planning your event.<br/><br/>Musical Events, Corporate Events, Hotels and Event Venues, Children’s Events, Fundraisers and Galas, Political events, Grand Openings, Arts and Culture Events, Outdoor Events like Music Festivals and Marathon, are only a few of the events where our services can be utilized to make sure your special event is everything that you hoped for.Next-G provides event security services planned for any size of private or public event. Whether the crowd size is in hundreds or thousands or the venues are big or small, from school auditoriums to sports stadiums and arenas, Next-G always has a security plan that fits to your event needs. We are masters in resolving special security problems caused by large audiences.',
    subservices: [
      {
        icon: '/eventsecurity.webp',
        title: 'Crowd Management',
        desc: 'Control and manage crowds for safety.',
      },
      {
        icon: '/perimeter-security.png',
        title: 'Perimeter Security',
        desc: 'Secure entrances and key areas at events.',
      },
      {
        icon: '/emergency-response.jpg',
        title: 'Emergency Response',
        desc: 'Quick intervention for incidents or emergencies.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🎉',
        title: 'Crowd Management',
        desc: 'Ensuring safe flow and behavior of event attendees.',
      },
      {
        icon: '🛡️',
        title: 'Incident Response',
        desc: 'Quick intervention for emergencies or disturbances.',
      },
      {
        icon: '📋',
        title: 'Planning & Coordination',
        desc: 'Security planning tailored for each event.',
      },
    ],
    downHeader: 'Why Choose Next-G Services for Event Security',
    downSubHeader:
      'Next-G Services ensures your events are secure, safe, and professionally managed.',
    link: '/event-security',
  },
  {
    mainHeader: 'Retail Security',
    mainSubHeader:
      '<span style="color:white;font-weight:600;font-size:1.6rem;">Next-G is a master in the security business when it comes to retail facilities. We have secured numerous retail stores across the country and are expert in providing security solutions for retailers of all kinds.</span><br/><br/>Focused on delivering ideal solutions as per client’s requirement, we realize that our client’s are looking for effective and efficient solutions for asset protection, loss prevention, crowd control, and protection against workplace violence. We know that you seek for observance of moral business conduct and business protocol on a regular basis. Next-G can help you to relax and focus on just running your business. Focused on delivering ideal solutions as per client’s requirement, we realize that our client’s are looking for effective and efficient solutions for asset protection, loss prevention, crowd control, and protection against workplace violence. We know that you seek for observance of moral business conduct and business protocol on a regular basis. Next-G can help you to relax and focus on just running your business.<br/><br/>Having so many years of experience in retail industry, we strive to give customers the peace of mind, and support return business. Irrespective of what your business is, or where it is located, Next-G has a perfect security program that will assist you boost your bottom line.',
    subservices: [
      {
        icon: '/retailsecurity.webp',
        title: 'Store Guarding',
        desc: 'Trained guards for retail outlets.',
      },
      {
        icon: '/cctv-monitoring.jpg',
        title: 'CCTV Monitoring',
        desc: 'Constant monitoring of store premises.',
      },
      {
        icon: '/loss-prevention.webp',
        title: 'Loss Prevention',
        desc: 'Prevent theft and minimize losses.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏬',
        title: 'Asset Protection',
        desc: 'Minimize theft and damages in retail stores.',
      },
      {
        icon: '👀',
        title: 'Monitoring',
        desc: 'CCTV and patrols to safeguard staff and customers.',
      },
      {
        icon: '🛡️',
        title: 'Trained Security',
        desc: 'Retail-specific security training and protocols.',
      },
    ],
    downHeader: 'Why Choose Next-G Services for Retail Security',
    downSubHeader:
      'Next-G Services delivers reliable retail security solutions for businesses of all sizes.',
    link: '/retail-security',
  },
  {
    mainHeader: 'Students Accommodation Associates (CSA)',
    mainSubHeader:
      "<span style='color:white;font-weight:600;font-size:1.6rem;'>Next-G provides trusted student accommodation services through CSA. We specialize in offering safe, affordable, and well-managed housing solutions for students across the country.</span><br/><br/> Focused on delivering ideal living arrangements as per client and student requirements, we understand the importance of comfort, safety, and community in every environment. Our team ensures properties are well-maintained, support staff are trained, and every accommodation program is executed with precision, providing peace of mind to both students and parents.<br/><br/>With years of experience in student housing and property management, Next-G guarantees professional service for long-term stays, short-term rentals, and specialized accommodation needs, allowing students to focus on their studies while leaving housing management in expert hands.",
    subservices: [
      {
        icon: '/studenthousing.jpg',
        title: 'Safe & Secure Housing',
        desc: 'We provide well-managed and secure accommodation facilities designed for student comfort and safety.',
      },
      {
        icon: '/affordablehousing.webp',
        title: 'Affordable Living Solutions',
        desc: 'Budget-friendly housing options without compromising on quality, convenience, or essential amenities.',
      },
      {
        icon: '/communitysupport.webp',
        title: 'Community & Support Services',
        desc: 'Dedicated support staff and community programs to help students settle and thrive in their new environment.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏠',
        title: 'Trusted Accommodation',
        desc: 'Properties managed with care, ensuring safety and reliability for students and parents.',
      },
      {
        icon: '💰',
        title: 'Affordable Options',
        desc: 'Flexible pricing and packages tailored to student needs and budgets.',
      },
      {
        icon: '🎓',
        title: 'Student-Centric Approach',
        desc: 'Focused on creating a supportive environment that enhances student life and learning.',
      },
    ],
    downHeader: 'Why Choose Next-G for Student Accommodation',
    downSubHeader:
      'Our CSA team combines expertise, care, and professionalism to ensure safe, affordable, and supportive housing for students.',
    link: '/students-accommodation',
  },
  {
    mainHeader: 'Unoccupied Property Monitoring',
    mainSubHeader:
      "<span style='color:white;font-weight:600;font-size:1.6rem;'>Next-G is an expert in monitoring and protecting unoccupied properties, including homes, offices, and commercial facilities.</span><br/><br/> We have successfully safeguarded numerous properties nationwide, providing peace of mind to property owners. Focused on delivering ideal security solutions, we understand the need for 24/7 supervision, risk prevention, and thorough inspections to ensure assets remain safe and intact. Our professional team prevents vandalism, theft, and unauthorized access while allowing clients to focus on their priorities.<br/><br/>With years of experience in property monitoring and risk management, Next-G ensures comprehensive protection, frequent inspections, and rapid response protocols to maintain security and minimize potential threats for unoccupied properties.",
    subservices: [
      {
        icon: '/propertyguard.jpg',
        title: 'Overnight Security',
        desc: 'Personnel stationed at properties to prevent trespassing and protect assets during off-hours.',
      },
      {
        icon: '/propertycheck.webp',
        title: 'Routine Property Checks',
        desc: 'Regular inspections to ensure the property remains secure and intact.',
      },
      {
        icon: '/alarmsystems.webp',
        title: 'Alarm & Surveillance Monitoring',
        desc: 'Installation and monitoring of alarms and surveillance systems for enhanced property security.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏠',
        title: 'Reliable Protection',
        desc: 'Consistent security measures for peace of mind.',
      },
      {
        icon: '🔒',
        title: 'Experienced Staff',
        desc: 'Trained personnel with expertise in property monitoring.',
      },
      {
        icon: '🕒',
        title: '24/7 Monitoring',
        desc: 'Continuous supervision to prevent incidents at any time.',
      },
    ],
    downHeader: 'Why Choose Next-G for Unoccupied Property Security',
    downSubHeader:
      'Our team ensures unoccupied properties are monitored professionally, minimizing risk and providing owners with peace of mind.',
    link: '/unoccupied-property-monitoring',
  },
];
